<template>
  <div class="content">
    <tm-divider class="p-mb-3 p-mt-0" />
    <div v-for="(placeholder, i) in availablePlaceholders" :key="i">
      <tm-button type="link" class="p-mb-1" @click="selectPlaceholder(placeholder)">{{ placeholder }}</tm-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import useDialog from '@composables/useDialog';
import { computed } from 'vue';

const { close: closeDialog, dialog } = useDialog();

const availablePlaceholders = computed(() => dialog.value.data?.placeholders || []);

const selectPlaceholder = (placeholder: string) => {
  dialog.value.callback?.onPlaceholderSelection?.(placeholder);
  closeDialog();
};
</script>

<style scoped>
.content {
  min-width: 20rem;
}
</style>
